import type { AnchorHTMLAttributes } from 'react';

import { ButtonProps } from './button-props';

export type ButtonAnchorProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'tabIndex'
>;

export const getButtonAnchorProps = (
  link?: ButtonProps['link'],
): ButtonAnchorProps | undefined => {
  if (!link) {
    return undefined;
  }
  return typeof link === 'string' ? { href: link } : link;
};
